<template>
  <div class="container-fluid">
    <projects-list
      :is-project-module="false"
      :filters="filters"
      variant="preapproved"/>
  </div>
</template>

<script>
import ProjectsList from "@/components/ProjectRequestsList";
export default {
  name: "ProjectInRevisionList",
  components: {ProjectsList},
  data: () => ({
    filters: {
      'projects.status': [1,2,3],
      resolution: 0
    }
  }),
}
</script>

<style scoped>

</style>
